import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { warwickConfig } from "./data";

export default function WarwickPage() {
  return <CityPageTemplate config={warwickConfig} />;
}